export default function getGstateName(longName) {
  if (longName && longName.toLowerCase().endsWith("county")) {
    return longName.substring(0, longName.length - 7);
  }
  return longName;
}
